/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return WorkloadDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<WorkloadDefinitionVersion>): WorkloadDefinitionVersion {
        let obj = Object.assign(new WorkloadDefinitionVersion(), model);
        WorkloadDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadDefinitionVersion>): WorkloadDefinitionVersion {
        if (!model) return null;
        return WorkloadDefinitionVersion.newInstance(<WorkloadDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadDefinitionVersion) {
        if (!obj) return;

        models.WorkloadDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.WorkloadConfiguration.fixupPrototype(this.details);
        }
    }

    /**
     * Details of the version
     */
    details: models.WorkloadConfiguration;

}
